import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Timer } from 'src/app/interfaces/timer.interface';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class TimerService {
  constructor(private http: HttpClient) { }

  createTimer(timer: Timer) {
    return this.http.post<Timer>(`${environment.apiUrl}/api/timers/add`, timer);
  }

  updateTimer(id: string, timer: Timer) {
    return this.http.patch<Timer>(`${environment.apiUrl}/api/timers/update/${id}`, timer);
  }

  deleteTimer(id: string) {
    return this.http.delete(`${environment.apiUrl}/api/timers/delete/${id}`);
  }

  getTimers() {
    return this.http.get<Timer[]>(`${environment.apiUrl}/api/timers`);
  }

  activeTimer(id: string, timer: Timer) {
    return this.http.post<Timer>(`${environment.apiUrl}/api/timers/active/${id}`, timer);
  }

  getTimersData() {
    return this.http.get<{ activeTimer: Timer, timers: Timer[] }>(`${environment.apiUrl}/api/timers/data`);
  }

}
